import { useEffect, useRef } from "react";

export default function FeaturesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".feature-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToCta = () => {
    const el = document.querySelector("#cta");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="features"
      ref={sectionRef}
      className="relative w-full overflow-hidden bg-[#0a0a0a]"
    >
      <div className="relative z-10 max-w-[1024px] mx-auto px-6 py-20 md:py-28">
        <div className="max-w-[640px] mx-auto text-center">
          <h2 className="feature-animate animate-on-scroll text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.1] tracking-tight text-white mb-5">
            HURMA
            <br />
            <span className="gradient-text-shimmer">ідеальний найм в ритейлі.</span>
          </h2>

          <p className="feature-animate animate-on-scroll text-[17px] text-white/80 leading-relaxed mb-10 max-w-[520px] mx-auto">
            Ви не просто купуєте «зручну програму» — ви отримуєте прозору аналітику, де видно, куди йдуть ваші гроші, чому кандидати відмовляються і як зробити так, щоб ваші торгові точки завжди були з персоналом.
          </p>

          <div className="feature-animate animate-on-scroll flex flex-col items-center sm:flex-row gap-4 justify-center">
            <a
              href="https://hurma.work/request-2/?utm_source=retail_landing&utm_medium=demo&utm_campaign=2026"
              target="_blank"
              rel="noopener noreferrer"
              className="gradient-bg text-white text-[13px] sm:text-[14px] font-medium px-5 sm:px-7 py-2.5 sm:py-3 rounded-full hover:opacity-90 transition-opacity inline-flex items-center whitespace-nowrap"
            >
              Замовити демо
              <i className="ri-arrow-right-line ml-1.5 text-sm" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}